import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import emailjs from '@emailjs/browser';

import 'bootstrap/dist/css/bootstrap.min.css';
import './footer.css';

const Footer = () => {
    const location = useLocation();
    const isContactPage = location.pathname === '/contact';

    const [contactForm, setContactForm] = useState({
        name: '',
        email: '',
        subject:'',
        phone: '',
        message: ''
    });

    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState({ message: '', error: false });

    const clearStatus = () => {
        setStatus({ message: '', error: false });
    };

    const handleInputChange = (field, value) => {
        clearStatus();
        setContactForm({...contactForm, [field]: value});
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setStatus({ message: '', error: false });

        try {
            const templateParams = {
                from_name: contactForm.name,
                from_email: contactForm.email,
                subject:contactForm.subject,
                phone: contactForm.phone,
                message: contactForm.message,
            };

            await emailjs.send(
                process.env.REACT_APP_EMAILJS_SERVICE_ID,
                process.env.REACT_APP_EMAILJS_FOOTER_CONTACT_FORM_TEMPLATE_ID,
                templateParams,
                process.env.REACT_APP_EMAILJS_PUBLIC_KEY
            );

            setStatus({
                message: 'Message sent successfully!',
                error: false
            });

            setContactForm({
                name: '',
                email: '',
                subject:'',
                phone: '',
                message: ''
            });

        } catch (error) {
            console.error('EmailJS error:', error);
            setStatus({
                message: 'Failed to send message. Please try again.',
                error: true
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="footer-wrapper">
       {!isContactPage && (
    <div className="footer-top">
        <div className="container">
            <div className="row align-items-center">
                <div className="col-lg-6 mb-4 mb-lg-0">
                    <div className="footer-top-image">
                        <img src="/assets/get-in-touch-form-image.png" alt="Contact Us" className="img-fluid rounded" />
                    </div>
                </div>
                
                <div className="col-lg-6">
                    <div className="contact-form-card">
                        <div className="text-center mb-4">
                            <h2 className="main-heading mb-2">Get In Touch</h2>
                        </div>

                        {status.message && (
                            <div className={`alert ${status.error ? 'alert-danger' : 'alert-success'} mb-4`}>
                                {status.message}
                            </div>
                        )}

                        <form onSubmit={handleSubmit}>
                            <div className="row g-4">
                                <div className="col-md-6">
                                    <div className="input-group">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Full Name"
                                            value={contactForm.name}
                                            onChange={(e) => handleInputChange('name', e.target.value)}
                                            required
                                        />
                                        <i className="fas fa-user position-absolute end-3 top-50 translate-middle-y text-gray-400"></i>
                                    </div>
                                </div>
                                
                                <div className="col-md-6">
                                    <div className="input-group">
                                        <input
                                            type="email"
                                            className="form-control"
                                            placeholder="Email Address"
                                            value={contactForm.email}
                                            onChange={(e) => handleInputChange('email', e.target.value)}
                                            required
                                        />
                                        <i className="fas fa-envelope position-absolute end-3 top-50 translate-middle-y text-gray-400"></i>
                                    </div>
                                </div>

                                <div className="col-12">
                                    <div className="input-group">
                                        <input
                                            type="tel"
                                            className="form-control"
                                            placeholder="Phone Number"
                                            value={contactForm.phone}
                                            onChange={(e) => handleInputChange('phone', e.target.value)}
                                            required
                                        />
                                        <i className="fas fa-phone position-absolute end-3 top-50 translate-middle-y text-gray-400"></i>
                                    </div>
                                </div>

                                <div className="col-12">
                                    <div className="input-group">
                                        <select
                                            className="form-control"
                                            value={contactForm.subject || ''}
                                            onChange={(e) => handleInputChange('subject', e.target.value)}
                                            required
                                        >
                                            <option value="">Choose Subject</option>
                                            <option value="general">General Inquiry</option>
                                            <option value="support">Support</option>
                                            <option value="feedback">Feedback</option>
                                        </select>
                                        <i className="fas fa-chevron-down position-absolute end-3 top-50 translate-middle-y text-gray-400"></i>
                                    </div>
                                </div>

                                <div className="col-12">
                                    <textarea
                                        className="form-control"
                                        placeholder="Your Message"
                                        rows="5"
                                        value={contactForm.message}
                                        onChange={(e) => handleInputChange('message', e.target.value)}
                                        required
                                    ></textarea>
                                </div>

                                <div className="col-12 d-flex flex-column flex-sm-row justify-content-between gap-3">
                                    <button
                                        type="submit"
                                        className="btn btn-success px-4"
                                        disabled={loading}
                                    >
                                        {loading ? 'SENDING...' : 'SUBMIT NOW'}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
)}
 {/* Main Footer - Redesigned to match the image */}
            <footer style={{ backgroundColor: '#4a1810', color: 'white', padding: '3rem 0 1rem' }}>
                <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 1rem' }}>
                    <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr', gap: '3rem', marginBottom: '2rem' }}>
                        
                        {/* Contact Us Section */}
                        <div>
                            <h3 style={{ color: '#dc3545', fontSize: '1.5rem', marginBottom: '1.5rem', fontWeight: 'bold' }}>Contact Us</h3>
                            
                            <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '1.5rem' }}>
                                <div style={{ 
                                    width: '60px', 
                                    height: '60px', 
                                    backgroundColor: '#fff', 
                                    borderRadius: '8px', 
                                    display: 'flex', 
                                    alignItems: 'center', 
                                    justifyContent: 'center',
                                    marginRight: '1rem',
                                    fontSize: '1.5rem'
                                }}>
                                                                    <img src="/assets/icons/klm-icon.png"  className="me-2"   alt="KLM icon"  height="40"width="40"/>
 
                                </div>
                                <div>
                                    <h4 style={{ color: '#dc3545', fontSize: '1.2rem', marginBottom: '0.5rem' }}>KLM Packaging Industries</h4>
                                    <div style={{ color: '#ccc', lineHeight: '1.6', fontSize: '0.9rem' }}>
                                        <p style={{ margin: '0.25rem 0' }}>PLOT NO.124, BEHIND WELSPUN, INDUSTRIAL PARK</p>
                                        <p style={{ margin: '0.25rem 0' }}>CHANDANVELLY, SHABAD (MDL), RANGA REDDY (DIST),</p>
                                        <p style={{ margin: '0.25rem 0' }}>HYDERABAD, TELANGANA-501503</p>
                                    </div>
                                </div>
                            </div>

                            {/* Map placeholder */}
                            <div style={{ 
                                width: '280px', 
                                height: '160px', 
                                backgroundColor: '#333', 
                                borderRadius: '8px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                border: '2px solid #555',
                                backgroundImage: 'url(https://images.unsplash.com/photo-1524661135-423995f22d0b?w=280&h=160&fit=crop&crop=center)',
                                backgroundSize: 'cover',
                                backgroundPosition: 'center'
                            }}>
                                                             <a href="https://maps.app.goo.gl/uWygWagoQfVaq7Di7" className="footer-nav-link" style={{ textDecoration: 'none' }}>

                                <div style={{ 
                                    backgroundColor: 'rgba(0,0,0,0.7)', 
                                    padding: '0.5rem 1rem', 
                                    borderRadius: '4px',
                                    color: 'white',
                                    fontSize: '0.9rem'
                                }}>
                                    📍 View on Map
                                </div>
                                </a>
                            </div>
                        </div>

                        {/* Tags Section */}
                        <div>
                            <h3 style={{ color: '#dc3545', fontSize: '1.5rem', marginBottom: '1.5rem', fontWeight: 'bold' }}>Products</h3>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.8rem' }}>
                                <a href="/paper-bags" className="footer-nav-link" style={{ textDecoration: 'none' }}>
                                <div style={{ color: '#dc3545', textDecoration: 'none', fontSize: '1.1rem', fontWeight: '500', cursor: 'pointer' }}>Paper Bags</div>
                                </a>
                             <a href="/courier-bags" className="footer-nav-link" style={{ textDecoration: 'none' }}>

                                <div style={{ color: '#dc3545', textDecoration: 'none', fontSize: '1.1rem', fontWeight: '500', cursor: 'pointer' }}>Courier Bags</div>
                                </a>
                                                                <a href="/packaging-products" className="footer-nav-link" style={{ textDecoration: 'none' }}>

                                <div style={{ color: '#dc3545', textDecoration: 'none', fontSize: '1.1rem', fontWeight: '500', cursor: 'pointer' }}>Packaging Products</div>
                                </a>
                                {/* <div style={{ color: '#dc3545', textDecoration: 'none', fontSize: '1.1rem', fontWeight: '500', cursor: 'pointer' }}>Corrugation Box</div> */}
                            </div>
                        </div>

                        {/* Quick Links Section */}
                        <div>
                            <h3 style={{ color: '#dc3545', fontSize: '1.5rem', marginBottom: '1.5rem', fontWeight: 'bold' }}>Quick Links</h3>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.8rem' }}>
                               <a href="/" className="footer-nav-link" style={{ textDecoration: 'none' }}>
    <div style={{ color: '#dc3545', textDecoration: 'none', fontSize: '1.1rem', fontWeight: '500', cursor: 'pointer' }}>Home</div>
</a>
<a href="/about" className="footer-nav-link" style={{ textDecoration: 'none' }}>
    <div style={{ color: '#dc3545', textDecoration: 'none', fontSize: '1.1rem', fontWeight: '500', cursor: 'pointer' }}>About us</div>
</a>
<a href="/products" className="footer-nav-link" style={{ textDecoration: 'none' }}>
    <div style={{ color: '#dc3545', textDecoration: 'none', fontSize: '1.1rem', fontWeight: '500', cursor: 'pointer' }}>Products</div>
</a>
<a href="/blogs" className="footer-nav-link" style={{ textDecoration: 'none' }}>
    <div style={{ color: '#dc3545', textDecoration: 'none', fontSize: '1.1rem', fontWeight: '500', cursor: 'pointer' }}>Blogs</div>
</a>
                            </div>
                        </div>
                    </div>

                    {/* Dotted separator */}
                    <div style={{ 
                        borderTop: '2px dotted #666', 
                        margin: '2rem 0',
                        paddingTop: '1.5rem'
                    }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '1rem' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '2rem', flexWrap: 'wrap' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                    {/* <span style={{ color: '#dc3545', fontSize: '1.2rem' }}>🕒</span> */}
                                    {/* <div>
                                        <div style={{ color: '#dc3545', fontWeight: 'bold' }}>Monday to Saturday</div>
                                        <div style={{ color: '#ccc', fontSize: '0.9rem' }}>09.00 am to 7.00 pm</div>
                                    </div> */}
                                </div>
                                
                                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                    <span style={{ color: '#dc3545', fontSize: '1.2rem' }}>✉️</span>
                                    <div style={{ color: '#ccc' }}>sales@klmpack.com / info@klmpack.com</div>
                                </div>
                            </div>
                            
                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                <span style={{ color: '#dc3545', fontSize: '1.2rem' }}>📞</span>
                                <div style={{ color: '#dc3545', fontWeight: 'bold' }}>+91 90634 27464 / +91 79950 04136</div>
                            </div>
                        </div>
                    </div>

                    {/* Final dotted separator */}
                    <div style={{ borderTop: '2px dotted #666', paddingTop: '1rem' }}>
                        <div style={{ textAlign: 'center', color: '#888', fontSize: '0.9rem' }}>
                            © 2025 All Rights Reserved. KLM Packaging Industries
                        </div>
                    </div>
                </div>

                {/* WhatsApp Floating Button */}
                <a 
                    href="https://wa.me/919063427464" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="whatsapp-float"
                    title="Chat with us on WhatsApp"
                >
                    <svg width="30" height="30" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.465 3.516"/>
                    </svg>
                </a>

                {/* Responsive Styles */}
                <style jsx>{`
                 .footer-nav-link:hover div {
        color: #28a745 !important;
    }
    .footer-nav-link div {
        transition: color 0.3s ease;
    }

    .whatsapp-float {
        position: fixed;
        bottom: 30px;
        right: 30px;
        width: 60px;
        height: 60px;
        background-color: #25D366;
        color: white;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        text-decoration: none;
        box-shadow: 0 4px 12px rgba(37, 211, 102, 0.4);
        transition: all 0.3s ease;
        z-index: 1000;
        animation: pulse 2s infinite;
    }

    .whatsapp-float:hover {
        background-color: #20b954;
        color: white;
        transform: scale(1.1);
        box-shadow: 0 6px 20px rgba(37, 211, 102, 0.6);
    }

    @keyframes pulse {
        0% {
            box-shadow: 0 4px 12px rgba(37, 211, 102, 0.4);
        }
        50% {
            box-shadow: 0 4px 12px rgba(37, 211, 102, 0.7), 0 0 0 10px rgba(37, 211, 102, 0.1);
        }
        100% {
            box-shadow: 0 4px 12px rgba(37, 211, 102, 0.4);
        }
    }

                    @media (max-width: 768px) {
                        .footer-wrapper > div:first-child > div > div {
                            grid-template-columns: 1fr !important;
                            gap: 2rem !important;
                        }
                        
                        footer > div > div:first-child {
                            grid-template-columns: 1fr !important;
                            gap: 2rem !important;
                        }
                        
                        footer > div > div:nth-child(2) > div {
                            flex-direction: column !important;
                            align-items: flex-start !important;
                        }
                        
                        footer > div > div:nth-child(2) > div > div:first-child {
                            flex-direction: column !important;
                            gap: 1rem !important;
                        }

                        .whatsapp-float {
                            bottom: 20px;
                            right: 20px;
                            width: 50px;
                            height: 50px;
                        }

                        .whatsapp-float svg {
                            width: 25px;
                            height: 25px;
                        }
                    }
                `}</style>
            </footer>
        </div>
    );
};

export default Footer;